import { createSlice, nanoid, type PayloadAction } from "@reduxjs/toolkit";

import type { User } from "@/types/api";

interface UsersState {
  items: User[];
}

const seed: User[] = [
  {
    id: "u-1",
    email: "finance@luxfair.mt",
    name: "Joanna Vella",
    role: "finance_admin",
    active: true,
  },
  {
    id: "u-2",
    email: "accounts@luxfair.mt",
    name: "Mario Borg",
    role: "accounts_user",
    active: true,
  },
  {
    id: "u-3",
    email: "support@born.mt",
    name: "Born Digital Support",
    role: "developer",
    active: true,
  },
  {
    id: "u-4",
    email: "matthew@born.mt",
    name: "Matthew Galea",
    role: "commercial",
    active: true,
  },
  {
    id: "u-5",
    email: "audit@luxfair.mt",
    name: "External Auditor (provisioned)",
    role: "accounts_user",
    active: false,
  },
];

const initialState: UsersState = { items: seed };

export type UserInput = Omit<User, "id">;

const slice = createSlice({
  name: "users",
  initialState,
  reducers: {
    addUser(state, action: PayloadAction<UserInput>) {
      const id = `u-${nanoid(6)}`;
      state.items.unshift({ ...action.payload, id });
    },
    updateUser(state, action: PayloadAction<{ id: string; patch: Partial<User> }>) {
      const row = state.items.find((r) => r.id === action.payload.id);
      if (row) Object.assign(row, action.payload.patch);
    },
    toggleUserActive(state, action: PayloadAction<string>) {
      const row = state.items.find((r) => r.id === action.payload);
      if (row) row.active = !row.active;
    },
    deleteUser(state, action: PayloadAction<string>) {
      state.items = state.items.filter((r) => r.id !== action.payload);
    },
  },
});

export const { addUser, updateUser, toggleUserActive, deleteUser } = slice.actions;
export default slice.reducer;
